import { redirect, LoaderFunction } from 'react-router-dom'
import { useSessionStore } from '@/stores'

// Gated on the campaign flag, not on a subdomain type: the marketplace shares
// `/session` with the funnel, so a session can be valid without the catalog enabled.
export const marketplaceGuardLoader: LoaderFunction = async () => {
  const sessionStore = useSessionStore.getState()

  if (!sessionStore.isSessionValid() || !(sessionStore.session as any)?.show_marketplace) {
    throw redirect('/')
  }

  return null
}
